module.exports = __webpack_public_path__ + "static/media/sasha-stories-267941-unsplash.cb912b87.jpg";